import React, { useEffect } from "react";
import { Box, Flex, useColorModeValue, Image } from "@chakra-ui/react";
import NotificationBell from "@root/assets/images/notification.svg";
import HelpIcon from "@root/assets/images/help.svg";
import { useTranslation } from "react-i18next";
import SearchInput from "@root/components/common/text/SearchInput";
import { LanguageToggle } from "../sidebar/languagetoggler";
import useSidebar from "@root/hooks/useSidebar";
import { changeAppLanguage } from "@root/utils/change-language";
import { LANGUAGE } from "@root/constants";
import { useDispatch } from "react-redux";
import { updateLanguage } from "@root/store/slices/features";

interface HeaderProps {
  onSearch?: (query: string) => void;
  onNotificationClick?: () => void;
  onHelpClick?: () => void;
}

export const Header: React.FC<HeaderProps> = ({
  onSearch,
  onNotificationClick,
  onHelpClick,
}) => {
  const { languages } = useSidebar();
  const { t } = useTranslation("common");
  const dispatch = useDispatch();

  const bgColor = useColorModeValue("white", "gray.800");
  const borderColor = useColorModeValue("gray.200", "gray.600");

  useEffect(() => {
    changeAppLanguage(LANGUAGE.KOREAN);
    dispatch(updateLanguage(LANGUAGE.KOREAN));
  }, []);

  return (
    <Box
      bg={bgColor}
      borderBottom="1px solid"
      borderColor={borderColor}
      px={{ base: 4, md: 6 }}
      py={4}
      position="sticky"
      top={0}
    >
      <Flex
        alignItems="center"
        justify="space-between"
        gap={4}
        direction={{ base: "column", md: "row" }}
      >
        {/* Search Bar */}
        <Box
          flex={1}
          maxW="600px"
          width={{ base: "100%", md: "auto" }}
          borderRadius={"100px"}
        >
          {/* TODO: Will add later */}
          {/* <SearchInput placeholder={t("search")} borderRadius={"100px"} /> */}
        </Box>

        <Flex justifyContent={"center"} alignItems={"center"} gap={4}>
          {/* Language Toggle */}
          <LanguageToggle
            languages={languages}
            isSidebarOpen={true}
            isIcon={false}
          />
          {/* Notification Bell */}
          <Image src={NotificationBell} />
          {/* Help Icon */}
          <Image src={HelpIcon} />
        </Flex>
      </Flex>
    </Box>
  );
};
